import React, { useEffect, useState } from "react";

export default function Loader({ text = "Loading..." }) {
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSlow(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{
        width: "100%",
        padding: "60px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: 42,
          height: 42,
          border: "4px solid #e5e7eb",
          borderTop: "4px solid #4ade80",
          borderRadius: "50%",
          animation: "spin 0.9s linear infinite",
        }}
      />

      <p
        style={{
          marginTop: 12,
          fontSize: 14,
          color: "#6b7280",
        }}
      >
        {text}
      </p>

      {slow && (
        <p
          style={{
            marginTop: 8,
            fontSize: 13,
            color: "#6b7280",
            animation: "blink 1.2s ease-in-out infinite",
          }}
        >
          This may take a little longer, please hang tight.
        </p>
      )}

      <style>
        {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }

          @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0.3; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}
